import Vue from "vue";
import Vuex from "vuex";

import { moduleFactory } from "@/store/resource";
import { userModule as user } from "@/store/user";
import { messageModule as message } from "@/store/message";
import { searchModule as search } from "@/store/search";
import { tableModule as table } from "@/store/table";
import { onlineModule as online } from "@/store/online";
import { settingModule as setting } from "@/store/setting";
import { dialogModule as dialog } from "@/store/dialog";
import { moderationModule as moderation } from "@/store/moderation";
import { moderatorModule as moderatorOnline } from "@/store/moderator";
import { moderatorMetaModule as moderatorMeta } from "@/store/moderatorMeta";
import { transactionModule as transaction } from "@/store/transaction";
import { manualBackupModule as manualBackup } from "@/store/manualBackup";
import { mailSubjectModule as mailSubject } from "@/store/mailSubject";
import { profileVisitModule as profileVisit } from "@/store/profileVisit";
import balance from "@/store/balance";
import adminBadges from "@/store/adminBadges";
import backgroundTask from "@/store/backgroundTask";
import circularMailStatus from "@/store/circularMailStatus";
import publicProfileModal from "@/store/publicProfileModal";
import createPersistedState from "vuex-persistedstate";
import uploadProgress from "@/store/uploadProgress";
import roles from "@/store/role";
import permissions from "@/store/permission";
import ping from "@/store/ping";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [createPersistedState({ paths: ["search.filter"] })],
  state: {},
  modules: {
    balance,
    adminBadges,
    backgroundTask,
    circularMailStatus,
    table,
    message,
    user,
    search,
    online,
    dialog,
    customerProfile: moduleFactory("customerProfile"),
    uploadProgress,

    moderator: moduleFactory("moderator"),
    moderatorOnline,
    moderatorMeta,
    moderatorSupportMessage: moduleFactory("moderatorSupportMessage"),
    adminSupportMessage: moduleFactory("adminSupportMessage"),

    affiliate: moduleFactory("affiliate"),
    postback: moduleFactory("postback"),
    agency: moduleFactory("agency"),
    supportTicket: moduleFactory("supportTicket"),
    supportTicketResponse: moduleFactory("supportTicketResponse"),
    supportTicketResponseTemplate: moduleFactory(
      "supportTicketResponseTemplate"
    ),
    coupon: moduleFactory("coupon"),
    gift: moduleFactory("gift"),
    giftCategory: moduleFactory("giftCategory"),
    news: moduleFactory("news"),
    automaticMessageRule: moduleFactory("automaticMessageRule"),
    setting,
    blacklistModerator: moduleFactory("blacklistModerator"),
    blacklistUsername: moduleFactory("blacklistUsername"),
    mailConnectionSetting: moduleFactory("mailConnectionSetting"),
    accessControlAllowOrigin: moduleFactory("accessControlAllowOrigin"),
    asa: moduleFactory("asa"),
    cache: moduleFactory("cache"),
    transaction,
    manualBackup,
    userSetting: moduleFactory("userSetting"),
    moderation,
    priceLevel: moduleFactory("priceLevel"),
    userDeletion: moduleFactory("userDeletion"),
    circularMail: moduleFactory("circularMail"),
    publicProfileModal,
    roles,
    mailSubject,
    permissions,
    ping,
    profileVisit,
    faq: moduleFactory("faq")
  },
  strict: process.env.NODE_ENV !== "production"
});

export default store;
